export default __webpack_public_path__ + "static/media/img3.c42a0d9f.png";